export default __webpack_public_path__ + "static/media/UGA.4b706600.svg";